import { api } from "@/shared/api";

// ===== Types =====
// All types below: see proposals/2026-05-17-fe-generated-coverage-misc.md.
// generated `BrandAssetsDto` 仅 4 字段(logoUploadId/qrCodeUrl/phone/email),前端实际拿到的是
// 完整 {logos, qrs, titlePresets, colors, phone, email} 结构 — 这是 C(drift),V24 必须对齐。

// local-only: B (backend schema gap) — BrandAssets.logos 数组项
export interface LogoEntry {
  id: string;
  name: string;
  objectKey: string;
  isDefault: boolean;
  /** V6 fix4 backfilled by C2 — 自动分类的宽高比 */
  aspect?: "SQUARE" | "WIDE" | "TALL" | null;
  /** V6 fix4 — 自动采样的主色 #RRGGBB */
  colorHex?: string | null;
  /** V37 (2026-05-18) — backend getMy() 现签的 MinIO presigned GET URL(24h),只在响应里,replaceMy 不持久化 */
  signedUrl?: string | null;
}

// local-only: B (backend schema gap) — BrandAssets.qrs 数组项
export interface QrEntry {
  id: string;
  name: string;
  /** UPLOAD = 用 objectKey;URL = 用 url 字段 */
  mode: "UPLOAD" | "URL";
  objectKey?: string;
  url?: string;
  isDefault: boolean;
  /** V6 fix4 — 自动采样的主色 #RRGGBB(仅 UPLOAD 模式有值) */
  colorHex?: string | null;
  /** V37 (2026-05-18) — UPLOAD 模式 backend 现签的 URL,URL 模式留 null */
  signedUrl?: string | null;
}

// local-only: B (backend schema gap) — BrandAssets.titlePresets 数组项
export interface TitlePreset {
  id: string;
  posterTitle?: string;
  posterSubtitle?: string;
  isDefault: boolean;
}

// local-only: B (backend schema gap) — BrandAssets.colors
export interface ColorPalette {
  primary: string;
  secondary: string;
  accent: string;
}

// local-only: C (drift) — generated BrandAssetsDto 仅 logoUploadId/qrCodeUrl/phone/email,
// 前端实际拿 logos[] / qrs[] / titlePresets[] / colors{} 完整结构;V24 必须 reconcile yaml
export interface BrandAssets {
  logos: LogoEntry[];
  qrs: QrEntry[];
  titlePresets: TitlePreset[];
  colors: ColorPalette;
  // V11.6 (2026-05-12) — 联系方式 (brand-level 单一值), 跟 QR 同 PosterCard.
  // ai-service BrandInfo.phone/email 早已有, 前端没入口, 这里补上。
  phone?: string;
  email?: string;
}

// ===== Helpers =====

/** 取 list 的默认项;无默认则取第一项;空 list 返 null。 */
export function pickDefault<T extends { isDefault: boolean }>(list: T[] | undefined): T | null {
  if (!list || list.length === 0) return null;
  return list.find((x) => x.isDefault) ?? list[0];
}

/** 简易 id 生成器(crypto.randomUUID 截前 8 位)。 */
export function newAssetId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID().slice(0, 8);
  }
  return Math.random().toString(36).slice(2, 10);
}

// ===== API =====

export const brandAssetsService = {
  /** 任意 TENANT_STAFF 可读 — 创作页拉默认值。 */
  getMy: () => api.get<BrandAssets>("/tenant/brand-assets"),

  /** TENANT_MANAGER+ 全量替换。 */
  replaceMy: (dto: BrandAssets) => api.put<BrandAssets>("/tenant/brand-assets", dto),
};
